/*
 * The GTM container, shared by the places that have to name it at runtime.
 *
 * nuxt.config.js still holds its own literal because it is read before this
 * module is available; keep the two in step.
 */
export const GTM_ID = 'GTM-5GH35Q5';
